// v79 — a BD's own verdict changes (private to them) and the owner's demo blur.
import { createContext, useContext } from "react";
import { RATING } from "@/lib/creator360";
import { day } from "@/lib/c360Profile";

export const CYAN = "#00F0FF";
export const effR = (av, d) => d.mine?.[av]?.r || d.av[av].r;
export const rWord = (r) => RATING[r]?.label || "Not known";
export const changedLine = (m, kol) => `you changed it from ${rWord(kol)} to ${rWord(m.r)} on ${day(m.at)}`;

export const BlurCtx = createContext(false);
export const useBlur = () => useContext(BlurCtx);
// Text, links (not clickable while blurred) and media.
export const bl = (on, kind = "") => (on ? `c360-blur${kind ? ` c360-blur-${kind}` : ""}` : "");
